import { decode as base64_decode, encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

import Cookies from "js-cookie";
class NotificationStore {
  notification = [];
  getClass = [];
  getDriverName = [];
  allCompanyArray = [];

  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      notification: observable,
      getDriverName: observable,
      total: observable,
      loading: observable,
      loadData: action,
      getAllClass: action,
      addData: action,
      toGetDriverName: action,
      getNotificationDetails: action,
      getCompanies: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, companyId }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      offset: offset,
      limit: limit,
      page: 1,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=notification&a=getNotification",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/notifications/getNotification", {
        params: postData,
      });

    this.notification = response?.data?.data;
    this.loading = false;
  }

  async addData(values) {
    var postData = values;
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=notification&a=update", "postData=" + base64Input);

    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/notifications/saveNotification", values);
    return response.data;
  }

  async getNotificationDetails(id) {
    var postData = { id: id, limit: 1, offset: 0 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=notification&a=getNotification",
    //     "postData=" + base64Input
    //   );

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/notifications/getNotification", {
        params: postData,
      });

    return response?.data?.data[0];
  }

  async getAllClass() {
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=notification&a=getAllClass",
    //     "postData=" + base64Input
    //   );

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/notifications/getAllClass");

    let all = [{ classId: -1, className: "All" }, ...response?.data?.data];
    this.getClass = all;
    return response?.data?.data;
  }

  async getClassNames() {
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=notification&a=getAllClass",
    //     "postData=" + base64Input
    //   );

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/notifications/getAllClass");

    this.getClass = response?.data?.data;
    return response?.data?.data;
  }

  async toGetDriverName(companyId, isadmin) {
    // console.log(companyId,"dwee")
    var postData = {
      tokenId: "",
      companyId: companyId,
      isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
      deviceGrpOffSet: 0,
      deviceGrpSize: 10,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=company&a=getdata", "postData=" + base64Input);

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/company/getCompanyData", {
        params: postData,
      });
    this.getDriverName = await response?.data?.data?.company[0]?.drivers;

    return this.getDriverName;
  }

  async deleteRecord({ notification_Id, companyId }) {
    var postData = {
      tokenId: "",
      notification_Id: notification_Id,
      companyId: companyId,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=notification&a=delete", "postData=" + base64Input);

    var response = await postApi
      .getClient("")
      .delete(
        `https://dolphin.trackeazy.com/api/notifications/deleteNotification/${notification_Id}`
      );
    return response;
  }

  async getCompanies() {
    this.loading = true;
    var postData = {
      value: "",
      isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
      companyId: JSON.parse(base64_decode(Cookies.get("data"))).userCompanyId,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=company&a=getCompanyList", "postData=" + base64Input);

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/company/getCompanyList", {
        params: postData,
      });

    // this.allCompanyArray = response.data.data.companies;
    this.allCompanyArray = response.data.data.companydata;
    this.loading = false;
  }

  async getCompanyDataById(companyId) {
    var postData = { value: companyId, getBy: "companyId" };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=company&a=getCompanyList", "postData=" + base64Input);
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/company/getCompanyList", {
        params: postData,
      });
    return response.data.data.companydata.map((user) => ({
      label: user.name,
      value: user.companyId,
    }));
  }
}

export default NotificationStore;
